import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPayPalModule } from 'ngx-paypal';
import { TranslateModule } from '@ngx-translate/core';

import { PostPurchaseNavigationComponent } from './post-purchase-navigation.component';

@NgModule({
  declarations: [
    PostPurchaseNavigationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,  
    NgxPayPalModule,
    TranslateModule
  ],
  exports: [
    PostPurchaseNavigationComponent
  ]
})
export class PostPurchaseNavigationModule { }
